import {metadaApi} from '@dms/api/base';

import {
  GetIntegratedServicesApiResponse,
  GetIntegratedServicesApiArg,
  GetSelectableMaterialsIntegrationsApiResponse,
  GetSelectableMaterialsIntegrationsApiArg,
  GetTenantIntegrationsAdvancedSearchApiResponse,
  GetTenantIntegrationsAdvancedSearchApiArg,
  GetTenantIntegrationsAdvancedSearchApiResponseSchema,
  GetTenantIntegrationsAdvancedSearchApiArgSchema,
} from './types';

const metadaAdminIntegrationsApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getIntegratedServices: build.query<
      GetIntegratedServicesApiResponse,
      GetIntegratedServicesApiArg
    >({
      query: () => ({
        url: `/admin/v1/tenant/integrated-service`,
      }),
      providesTags: ['integratedServices'],
    }),
    getSelectableMaterialsIntegrations: build.query<
      GetSelectableMaterialsIntegrationsApiResponse,
      GetSelectableMaterialsIntegrationsApiArg
    >({
      query: () => ({
        url: '/admin/v1/integrations/selectable-material',
      }),
    }),
    getTenantIntegrationsAdvancedSearch: build.query<
      GetTenantIntegrationsAdvancedSearchApiResponse,
      GetTenantIntegrationsAdvancedSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/v1/tenant/${queryArg.tenantId}/integrations`,
        params: {
          branchId: queryArg.branchId,
          authorizationProfileId: queryArg.authorizationProfileId,
          authorizationId: queryArg.authorizationId,
          integrationCode: queryArg.integrationCode,
        },
      }),
      extraOptions: {
        responseSchema: GetTenantIntegrationsAdvancedSearchApiResponseSchema,
        requestSchema: GetTenantIntegrationsAdvancedSearchApiArgSchema,
      },
    }),
  }),
});
export const {
  useGetIntegratedServicesQuery,
  useGetSelectableMaterialsIntegrationsQuery,
  useGetTenantIntegrationsAdvancedSearchQuery,
} = metadaAdminIntegrationsApi;
